const list = [
  {
    __typename: 'HideJobFeedbackReason',
    key: 'wrong_location',
    label: 'Wrong location',
  },
  {
    __typename: 'HideJobFeedbackReason',
    key: 'salary_too_low',
    label: 'Salary too low',
  },
  {
    __typename: 'HideJobFeedbackReason',
    key: 'not_interested_in_this_role',
    label: 'Not interested in this role',
  },
  {
    __typename: 'HideJobFeedbackReason',
    key: 'seen_it_before',
    label: 'Seen it before',
  },
  {
    __typename: 'HideJobFeedbackReason',
    key: 'wrong_seniority_level',
    label: 'Wrong seniority level',
  },
  {
    __typename: 'HideJobFeedbackReason',
    key: 'job_posting_is_too_old',
    label: 'Job posting is too old',
  },
];

export const mockHideJobFeedbackReasons = (limit: number = list.length) =>
  list.slice(0, limit);
